// Action Types

export const SHOW_RAID_LOGGED_ENCOUNTER_LOADING_SPINNER = 'SHOW_RAID_LOGGED_ENCOUNTER_LOADING_SPINNER';
export const SET_RAID_LOGGED_ENCOUNTER_LIST = 'SET_RAID_LOGGED_ENCOUNTER_LIST';
export const SET_RAID_LOGGED_ENCOUNTER_PARAMETERS = 'SET_RAID_LOGGED_ENCOUNTER_PARAMETERS';
export const TOGGLE_OPEN_LOGGED_ENCOUNTER = 'TOGGLE_OPEN_LOGGED_ENCOUNTER';

// Action Creator
const RaidLoggedEncounterActionCreator = {
  setLoading(loading: boolean) {
    return {
      type: SHOW_RAID_LOGGED_ENCOUNTER_LOADING_SPINNER,
      payload: {
        loading
      }
    };
  },
  setRaidLoggedEncounterList(encounters: any) {
    return {
      type: SET_RAID_LOGGED_ENCOUNTER_LIST,
      payload: {
        encounters
      }
    };
  },
  setRaidLoggedEncounterParameters(params: any) {
    return {
      type: SET_RAID_LOGGED_ENCOUNTER_PARAMETERS,
      payload: {
        params
      }
    };
  },
  toggleOpenLoggedEncounter(runId: number) {
    return {
      type: TOGGLE_OPEN_LOGGED_ENCOUNTER,
      payload: runId
    };
  }
};

export default RaidLoggedEncounterActionCreator;
